import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './NotreHistoire.css';

const NotreHistoire = () => {
  
  // Scroll en haut au chargement de la page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Notre Histoire | ATAA REALTY — Cabinet d'Expertise Immobilière au Maroc"
        description="L'histoire d'ATAA REALTY : cabinet marocain d'expertise immobilière né d'une conviction simple — la valeur ne se proclame pas, elle se construit, se démontre et se transmet."
        canonical="https://ataarealty.com/notre-histoire"
        keywords="histoire ATAA Realty, cabinet expertise immobilière Maroc, expertise indépendante immobilier, RICS Maroc, IVS Maroc"
      />
      <Navbar />

      {/* 1. Header Landing */}
      <header className="history-header">
        <div className="history-overlay"></div>
        <div className="history-title-box anim-up">
          <span className="history-subtitle">GENÈSE & VISION</span>
          <h1>NOTRE HISTOIRE</h1>
        </div>
      </header>

      {/* 2. Contenu */}
      <section className="history-content-section">
        <div className="container">
          <div className="history-grid">
            
            {/* Colonne Gauche : Texte */}
            <div className="history-text-col">
              <h2 className="anim-up delay-1">L'Excellence comme Fondement</h2>
              
              <p className="anim-up delay-1">
                <strong>ATAA REALTY</strong> est née d’une conviction simple : la valeur ne se proclame pas, elle se construit, se démontre et se transmet.
              </p>

              <p className="anim-up delay-2">
                À l’origine du cabinet, il y a un itinéraire entre ingénierie, expertise immobilière, droit et fiscalité, nourri par une pratique de terrain au Maroc et un dialogue constant avec les standards internationaux de l’évaluation immobilière et du conseil en immobilier.
              </p>

              <p className="anim-up delay-2">
                Le cabinet a été fondé pour répondre à un besoin devenu central sur le marché immobilier marocain : disposer d’analyses indépendantes, structurées et méthodologiquement fondées, capables d’éclairer des décisions à forts enjeux patrimoniaux, financiers et juridiques, pour des investisseurs, institutions, promoteurs et acteurs du secteur immobilier.
              </p>

              {/* Bloc mis en valeur pour la signification du nom */}
              <div className="highlight-box anim-up delay-3">
                <p>
                  Le nom <strong>ATAA</strong>, qui signifie « la valeur de donner », traduit une approche fondée sur le partage du savoir, la pédagogie dans l’expertise, et l’accompagnement durable des clients et partenaires dans leurs projets immobiliers.
                </p>
              </div>

              <p className="anim-up delay-3">
                Aujourd’hui, <strong>ATAA REALTY</strong> intervient à l’intersection de l’expertise immobilière, du conseil stratégique et de la formation professionnelle, sur des actifs et des projets où la précision, la rigueur et la responsabilité professionnelle sont essentielles.
              </p>

              {/* 3. Footer SEO Discret */}
              <div className="seo-micro-footer anim-up delay-3">
                <p>Cabinet d’expertise immobilière et de conseil basé au Maroc, intervenant auprès d’investisseurs, institutions et acteurs du marché immobilier.</p>
                <p className="seo-italic">Les prestations d’ATAA REALTY sont conduites en alignement avec les standards de la RICS et les International Valuation Standards (IVS).</p>
              </div>

            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default NotreHistoire;